"use strict";
exports.__esModule = true;
exports.squareDonutPath = void 0;
exports.squareDonutPath = "polygon(\n    0% 0%,\n    0% 100%,\n    25% 100%,\n    25% 25%,\n    75% 25%,\n    75% 75%,\n    25% 75%,\n    25% 100%,\n    100% 100%,\n    100% 0%\n    );\n";
